import React from 'react';
import { Info as InfoIcon, TriangleAlert, CircleX, CheckCircle } from 'lucide-react';

const Info = ({
  icon: Icon = InfoIcon,
  className = '',
  childrenClassName = '',
  type = 'info', // 'info', 'warning', 'error', 'success'
  children
}) => {
  const typeColors = {
    info: 'bg-primary-light border-accent-main text-primary-dark',
    warning: 'bg-yellow-100 border-yellow-400 text-yellow-800',
    error: 'bg-red-100 border-red-400 text-red-800',
    success: 'bg-green-100 border-green-400 text-green-800',
  };
  const defaultIcons = {
    info: InfoIcon,
    warning: TriangleAlert,
    error: CircleX,
    success: CheckCircle,
  };
  Icon = defaultIcons[type] || Icon;
  return (
    <div className={`${typeColors[type]} border rounded ${className}`}>
      <div className={`${typeColors[type]} border-l-4 p-4 rounded`}>
        <div className="flex">
          <div className="flex-shrink-0">
            <Icon className="h-5 w-5" />
          </div>
          <div className="ml-3 flex-1">
            <div className={`text-sm flex-1 ${childrenClassName}`}>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Info;